// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ActorType,
  AnchorType,
  AnnotationType,
  Visibility,
} from "./types";


export default __t.row({
  annotationId: __t.u64().primaryKey().name("annotation_id"),
  sessionId: __t.u64().name("session_id"),
  createdByPresenceId: __t.u64().name("created_by_presence_id"),
  createdByName: __t.string().name("created_by_name"),
  get createdByActorType() {
    return ActorType.name("created_by_actor_type");
  },
  get anchorType() {
    return AnchorType.name("anchor_type");
  },
  anchorElementId: __t.option(__t.string()).name("anchor_element_id"),
  worldX: __t.option(__t.f64()).name("world_x"),
  worldY: __t.option(__t.f64()).name("world_y"),
  worldZ: __t.option(__t.f64()).name("world_z"),
  content: __t.string(),
  get annotationType() {
    return AnnotationType.name("annotation_type");
  },
  get visibility() {
    return Visibility;
  },
  visibleToIdentitiesJson: __t.option(__t.string()).name("visible_to_identities_json"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  resolved: __t.bool(),
  resolvedBy: __t.option(__t.identity()).name("resolved_by"),
  resolvedAt: __t.option(__t.timestamp()).name("resolved_at"),
});
